export const SAVE_LEAD = 'save_lead'
export const GET_LEAD_BY_ID = 'get_lead_by_id'
export const GET_LEAD = 'get_lead'
export const GET_LEAD_FILTER = 'get_lead_filter'
export const GET_LEAD_ACTIVITY = 'get_lead_activity'
export const GET_LEAD_ACTIVITY_BY_ID = 'get_lead_activity_by_id'
export const GET_LEAD_ACTIVITY_LIST = 'get_lead_activity_list'
export const SAVE_ACTIVITY = 'save_activity'
export const INSPECTION_CREATED = 'INSPECTION_CREATED'
export const GET_CITY = 'GET_CITY'
export const INSPECTION_FORM = 'INSPECTION_FORM'
export const SEARCH_DEALER_MASTER = 'SEARCH_DEALER_MASTER'
export const PENDING_LIST = 'PENDING_LIST'
export const LEAD_APPROVAL_ACTION = 'LEAD_APPROVAL_ACTION'
export const ADDRESS_APPROVAL_PENDING_LIST = 'ADDRESS_APPROVAL_PENDING_LIST'
export const ADDRESS_APPROVAL = 'ADDRESS_APPROVAL'
export const ADDRESS_APPROVAL_PENDING_BY_ID = 'ADDRESS_APPROVAL_PENDING_BY_ID'
export const ADDRESS_UPDATE_LOGS = 'ADDRESS_UPDATE_LOGS'